import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./authSlice";
import CommentsSlice from "./commentsSlice";
import conversationSlice from "./conversationSlice";
import EventCommentsSlice from "./eventCommentsSlice";
import eventManagementSlice from "./eventManagementSlice";
import EventsSlice from "./eventsSlice";
import FeedsSlice from "./feedsSlice";
import liveUserSlice from "./liveUserSlice";
import loaderSlice from "./loaderSlice";
import messageBarSlice from "./messageBarSlice";
import messageReadSlice from "./messageRead";
import messageSlice from "./messageSlice";
import mobileChatSlice from "./mobileChatSlice";
import nodesSlice from "./nodesSlice";
import notificationSlice from "./notificationCounter";
import planSlice from "./planSlice";
import PostsSlice from "./postsSlice";
import pushSubscriptionReducer from "./pushSubscriptionSlice";
import searchUserSlice from "./searchUserSlice";
import UserImagesSlice from "./userImagesSlice";

export default configureStore({
  reducer: {
    auth: AuthSlice,
    nodes: nodesSlice,
    posts: PostsSlice,
    events: EventsSlice,
    comments: CommentsSlice,
    eventComments: EventCommentsSlice,
    feeds: FeedsSlice,
    userImages: UserImagesSlice,
    conversation: conversationSlice,
    message: messageSlice,
    liveUser: liveUserSlice,
    messageRead: messageReadSlice,
    notification: notificationSlice,
    mobileChatSlice,
    messageBarSlice,
    loaderSlice,
    planSlice,
    searchUser: searchUserSlice,
    pushSubscription: pushSubscriptionReducer,
    subscription: require('./subscriptionSlice').default,
    eventManagement: eventManagementSlice,
  },
  devTools: process.env.NODE_ENV !== "production",
});
